var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingeCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10228 8.99977L0 16.102L1.89765 17.9998L9 10.8975L16.1023 17.9998L18 16.102L10.8977 8.99977L17.9998 1.89765L16.1021 0L9 7.10205L1.89787 0L0.000214133 1.89765L7.10228 8.99977Z",
    fill: "#F51717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingeCloseRed);
export default __webpack_public_path__ + "static/media/SingeCloseRed.fb1c6d7307ca3fc342c4af369ee8bfc7.svg";
export { ForwardRef as ReactComponent };